import { i18n } from "../../translate/i18n";

export const ROWS_PER_PAGE = 20;

// Preset durations shown in the "Novo lote" select (minutes). "custom" lets the
// user type any number of minutes.
export const DURATION_PRESETS = [
  { value: 30 },
  { value: 60 },
  { value: 120 },
  { value: 240 },
  { value: 720 },
  ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 30].map((d) => ({ value: d * 1440 })),
];

/** Unidades da duração livre: minutos, horas ou dias (fator para minutos). */
export const DURATION_UNITS = [
  { value: "min", factor: 1 },
  { value: "h", factor: 60 },
  { value: "d", factor: 1440 },
];

// "90" -> "1h30" / "1440" -> "1 dia" / "45" -> "45 min"
export const formatarDuracao = (minutos) => {
  const total = Number(minutos);
  if (!Number.isFinite(total) || total <= 0) return "-";
  if (total % 1440 === 0) {
    const dias = total / 1440;
    return i18n.t("hotspot.duration.days", { count: dias });
  }
  if (total % 60 === 0) {
    const horas = total / 60;
    return i18n.t("hotspot.duration.hours", { count: horas });
  }
  if (total > 60) {
    const horas = Math.floor(total / 60);
    const min = total % 60;
    return `${horas}h${String(min).padStart(2, "0")}`;
  }
  return i18n.t("hotspot.duration.minutes", { count: total });
};

// centavos (integer) -> "R$ 12,34"
export const formatCentavos = (centavos) => {
  const n = Number(centavos);
  if (!Number.isFinite(n)) return "-";
  try {
    return (n / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  } catch (err) {
    return `R$ ${(n / 100).toFixed(2)}`;
  }
};

export const statusLabel = (status) => {
  const key = `hotspot.batchStatus.${status}`;
  const translated = i18n.t(key);
  return translated === key ? status || "-" : translated;
};

export const copyToClipboard = async (text) => {
  if (!text) return false;
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (err) {
    // fall through to legacy method below
  }
  try {
    const el = document.createElement("textarea");
    el.value = text;
    el.style.position = "fixed";
    el.style.opacity = "0";
    document.body.appendChild(el);
    el.focus();
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    return true;
  } catch (err) {
    return false;
  }
};
